import { render, staticRenderFns } from "./ChannelCredentialsWrapperView.vue?vue&type=template&id=46920334&scoped=true&"
import script from "./ChannelCredentialsWrapperView.vue?vue&type=script&lang=js&"
export * from "./ChannelCredentialsWrapperView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelCredentialsWrapperView.vue?vue&type=style&index=0&id=46920334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46920334",
  null
  
)

export default component.exports